import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Phone } from "lucide-react";
import { BRAND, IMAGES } from "../../lib/site";

const LINKS = [
  { label: "Services", id: "services" },
  { label: "Craft", id: "craft" },
  { label: "Gallery", id: "gallery" },
  { label: "Offers", id: "offers" },
];

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      data-testid="site-header"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-500 ${
        scrolled
          ? "bg-[#f9f6f0]/85 backdrop-blur-xl border-b border-[#2c1e16]/10 py-3"
          : "bg-transparent py-5"
      }`}
    >
      <div className="mx-auto max-w-[1400px] px-4 md:px-8 lg:px-12 flex items-center justify-between">
        <button
          data-testid="header-logo"
          onClick={() => scrollTo("top")}
          className="flex items-center gap-3"
        >
          <img src={IMAGES.logo} alt="Braiding Elevation Inc" className="h-11 w-11 object-contain" />
          <span className="font-display text-xl md:text-2xl leading-none tracking-tight text-[#2c1e16] text-left">
            Braiding<br className="hidden sm:block" />
            <span className="text-[#c96c31]">Elevation</span>
          </span>
        </button>

        <nav className="hidden lg:flex items-center gap-10">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}`}
              onClick={() => scrollTo(l.id)}
              className="font-body text-sm uppercase tracking-[0.18em] text-[#2c1e16]/70 hover:text-[#c96c31] transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            data-testid="header-call-link"
            href={BRAND.phoneHref}
            className="hidden md:flex items-center gap-2 font-body text-sm text-[#2c1e16]/70 hover:text-[#c96c31] transition-colors"
          >
            <Phone size={15} /> {BRAND.phone}
          </a>
          <button
            data-testid="header-book-btn"
            onClick={() => scrollTo("book")}
            className="rounded-full bg-[#c96c31] px-5 py-2.5 font-body text-sm font-medium text-[#f9f6f0] hover:bg-[#b35d27] hover:-translate-y-0.5 transition-all duration-300"
          >
            Book Now
          </button>
        </div>
      </div>
    </motion.header>
  );
};
